<div class="dialog-wrapper dialog-question-wrapper">
  <div class="dialog">
    <h3 mat-dialog-title class="dialog__header">
      {{ title }}
    </h3>
    <div mat-dialog-content class="dialog__content">
      <label
        >{{ message }}
        <textarea id="izitoast--input" placeholder="Reason" required></textarea>
      </label>
    </div>

    <div mat-dialog-actions class="dialog__actions">
      <button class="btn btn-danger-outline" (click)="onDismiss()">
        Cancel
      </button>
      <button class="btn btn-default" (click)="onConfirm()" [disabled]="!isValid()">Confirm</button>
    </div>
  </div>
</div>
